import { render } from "./ShowFiltersButton.vue?vue&type=template&id=4b0d08ee"
import script from "./ShowFiltersButton.vue?vue&type=script&setup=true&lang=js"
export * from "./ShowFiltersButton.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/forge/retail.digitalhq.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/admin/ui/Components/Common/Filters/ShowFiltersButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4b0d08ee"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4b0d08ee', __exports__)) {
    api.reload('4b0d08ee', __exports__)
  }
  
  module.hot.accept("./ShowFiltersButton.vue?vue&type=template&id=4b0d08ee", () => {
    api.rerender('4b0d08ee', render)
  })

}


export default __exports__